<h1 *ngIf="title" mat-dialog-title [ngClass]="level">
  {{title}}
</h1>

<mat-dialog-content>
  <div class="mat-dialog-text">
    {{message}}
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    {{'close' | transloco}}
  </button>
</mat-dialog-actions>
